module.exports = __webpack_public_path__ + "static/img/reward-bg.7f5ce765.webp";